import React from 'react'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import { BaseCard, CardField } from 'components'

export const CardRequisicao = (props) => {
  moment.locale('pt-br', localization)
  const { requisicao, handleClick } = props

  return (
    requisicao ? (
      <BaseCard
        avatar="REQUISICAO"
        title="Requisição"
        onClick={() => handleClick(requisicao.id)}
        onNovaAba={() => handleClick(requisicao.id, true)}
      >
        <CardField label="Autoridade Requisitante" value={requisicao.autoridadeRequisitante?.nome?.toUpperCase()} />
        <CardField label="Órgão de Origem" value={requisicao.orgaoOrigem?.nome?.toUpperCase()} />
        <CardField label="Identificador" value={requisicao.identificador} />
        <CardField label="RIP" value={requisicao.identificador_caso_rip} />
        <CardField label="Data de cadastro" value={moment(requisicao.createdAt).format('DD/MM/YYYY')} />
        <CardField label="Resumo da Ocorrência" value={requisicao.resumo_ocorrencia} />
      </BaseCard>
    ) : null
  )
}
